module.exports = __webpack_public_path__ + "5b5194d98f1ae04d1f8fe6fb645253c4.svg";